function BirdSong(room) {
    this.room = room;
    this.count = 9;
    this.sndBird = [];
}

BirdSong.prototype.entityManifestSpec =
    function () {
        for (var result = [], i = 1; i <= this.count; i++)
            result.push({full_id: 'bird-' + i, full_src: 'sounds/birdsong-' + i + '.wav'});

        return result;
    };

BirdSong.prototype.entityLoad =
    function () {
        this.sndBird = [];
        this.currentSound = null;

        for (var i = 1; i <= this.count; i++)
            this.sndBird.push(this.room.world.queue.getResult('bird-' + i))
    };

BirdSong.prototype.randomBirdId =
    function () {
        return 'bird-' + Aha.rand(1, this.count);
    };

BirdSong.prototype.randomSongInterval =
    function () {
        return Aha.rand(2000, 6000);
    };

BirdSong.prototype.sing =
    function () {
        this.timeoutId = window.setTimeout(function () {
            this.currentSound = createjs.Sound.play(this.randomBirdId(), {volume: 0.2});
            this.sing();
        }.bind(this), this.randomSongInterval());
    };

BirdSong.prototype.hush =
    function () {
        window.clearTimeout(this.timeoutId);
    };

